import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

import { ROUTES } from "~/constants/routing";
import { useFilter } from "~/providers/FilterProvider";
import { isDashboardPath } from "~/utils/isDashboardPath";

export const useGoToHomePage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { clearAllFilters, triggerDashboardHomeReset, setMarketSettings } =
    useFilter();

  return useCallback(() => {
    const homePath = ROUTES.main.createURL();
    const onDashboard = isDashboardPath(pathname);
    const onHome = pathname === homePath;

    if (onDashboard) {
      triggerDashboardHomeReset();
      setMarketSettings("ungroup", false);

      if (onHome) {
        clearAllFilters();
      } else {
        navigate(homePath);
      }
    } else {
      navigate(homePath);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [
    pathname,
    navigate,
    clearAllFilters,
    triggerDashboardHomeReset,
    setMarketSettings,
  ]);
};
